import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    borderRadius: '4px',
    padding: '6px 16px',
    minHeight: '36px',

    '& .MuiTypography-body1:first-letter': {
      textTransform: 'capitalize'
    },
    '& .MuiTypography-body1': {
      color: theme.palette.gray.darkGray,
    },
  },
  odd: {
    background: '#F3F4F6'
  }
}))

export default function LineList({ description, isOdd }) {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.container, isOdd ? classes.odd : '')}>
      <Typography variant={'body1'} component={'h3'}>
        {description}
      </Typography>
    </Box>
  )
}

LineList.propTypes = {
  description: PropTypes.string.isRequired,
  isOdd: PropTypes.bool.isRequired
}
